import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../../Storage';
import * as Colors from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'FilterTicketComponent';

var styles = AppSettings.styles;

class FilterTicket extends React.Component {
    constructor(props, context) {
        super(props);

        this.state = {
            startX: 0,
            scrollLeft: 0,
            isDown: false
        }

        this.sliderRef = null;

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
         
    }


    setSliderRef = (element) => {
        self.sliderRef = element;
        if (self.sliderRef) {
          this.addSliderEvents();
        } else {
          this.removeSliderEvents();
        }
      }

    addSliderEvents = () => {
        const slider =  self.sliderRef;
        if (slider) {
          slider.addEventListener('mousedown', this.handleMouseDown);
          slider.addEventListener('mouseleave', this.handleMouseLeave);
          slider.addEventListener('mouseup', this.handleMouseUp);
          slider.addEventListener('mousemove', this.handleMouseMove);
        }
      }
    
    removeSliderEvents = () => {
        const slider =  self.sliderRef;
        if(slider != null){
            slider.removeEventListener('mousedown', this.handleMouseDown);
            slider.removeEventListener('mouseleave', this.handleMouseLeave);
            slider.removeEventListener('mouseup', this.handleMouseUp);
            slider.removeEventListener('mousemove', this.handleMouseMove);
        }
    }

    handleMouseDown = (e) => {
        const slider =  self.sliderRef;
        if (slider) {
          this.setState({
            isDown: true,
            startX: e.pageX - slider.offsetLeft,
            scrollLeft: slider.scrollLeft
          });
          slider.classList.add('active');
        }
    }
    
    handleMouseLeave = () => {
        const slider =  self.sliderRef;
        if (slider) {
            this.setState({ isDown: false });
            slider.classList.remove('active');
        }
    }
    
    handleMouseUp = () => {
        const slider =  self.sliderRef;
        if (slider) {
            this.setState({ isDown: false });
            slider.classList.remove('active');
        }
    }
    
    handleMouseMove = (e) => {
        const slider =  self.sliderRef;
        if (this.state.isDown && slider) {
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - this.state.startX) * 1; // scroll-fast
            //slider.scrollLeft = this.state.scrollLeft - walk;
            slider.scrollLeft = Math.max(0, this.state.scrollLeft - walk);
        }
    }




    renderFilterV2(){
        const {counter, filter} = this.props;
        if (counter.total == 0) {
            return "";
        }

        if(filter.canale == 'proposte'){
            return "";
        }

        return (
            <div className="widget-filter" id="widget-filter_ticket">
                <ul className="widget-filter--list" ref={this.setSliderRef}>
                    <li className={`bet-all${filter.type == "" ? " active" : ""}`} onClick={this.setFilter.bind(this, "removeFilter")}>
                        <span className="widget-filter--label">Tutte</span>
                    </li>
                    <li className={`bet-opened${filter.type == "opened" ? " active" : ""}`} onClick={this.setFilter.bind(this, "opened")}>
                        <span className="widget-filter--label">In corso</span>
                        <span className="widget-filter--counter">{counter.opened}</span>
                    </li>
                    <li className={`bet-winning${filter.type == "winning" ? " active" : ""}`} onClick={this.setFilter.bind(this, "winning")}>
                        <span className="widget-filter--label">Vinte</span>
                        <span className="widget-filter--counter">{counter.winning}</span>
                    </li>
                    <li className={`bet-losing${filter.type == "losing" ? " active" : ""}`} onClick={this.setFilter.bind(this, "losing")}>
                        <span className="widget-filter--label">Perse</span>
                        <span className="widget-filter--counter">{counter.losing}</span>
                    </li>
                </ul>
            </div>
        );
            
    }

    renderFilter() {
        const {counter, filter} = this.props;
        if (counter.total == 0) {
            return "";
        }

        if(filter.canale == 'proposte'){
            return "";
        }

        let filterCounter = 0;
        var openedIcon = "";
        if (counter.opened > 0) {
            filterCounter += 1;
            openedIcon =
                        <li className={filter.type == "opened" ? 'bet-icons-filter opened-bet' : 'opened-bet'} onClick={this.setFilter.bind(this, "opened")}>
                            <span className='bet-status-label'>In corso <sup>{counter.opened}</sup></span>
                            {/* <span className='bet-status-counter'>{counter.opened}</span> */}
                        </li>
        }

        var losingIcon = "";
        if (counter.losing > 0) {
            filterCounter += 1;         
            losingIcon =
                        <li className={filter.type == "losing" ? 'bet-icons-filter losing-bet' : 'losing-bet'} onClick={this.setFilter.bind(this, "losing")}>
                            <span className='bet-status-label'>Persa <sup>{counter.losing}</sup></span>
                            {/* <span className='bet-status-counter'>{counter.losing}</span> */}
                        </li>
        }

        var winnigIcon = "";
        if (counter.winning > 0) {
            filterCounter += 1;
            winnigIcon =
            <li className={filter.type == "winning" ? 'bet-icons-filter winning-bet' : "winning-bet" } onClick={this.setFilter.bind(this, "winning")}>
                <span className='bet-status-label'>Vinta <sup>{counter.winning}</sup></span>
                {/* <span className='bet-status-counter'>{counter.winning}</span> */}
            </li>
        }


        var iconStyleAbort = JSON.parse(JSON.stringify(styles.topFilterIconStyle));
        iconStyleAbort['color'] = Colors.grey500
        if (filter.type == "" && filter.canale == "") {
            iconStyleAbort['opacity'] = "0.2"; 
        }
        
        var abortIcon = <IconButton iconClassName="fa fa-times"
            iconStyle={iconStyleAbort}
            onClick={this.setFilter.bind(this, "removeFilter")} />;

            if(filterCounter > 0) {
                return (
                    <div id="bar-bet-icons">
                       <ul className='bet-icons'>
                        {openedIcon}
                        {winnigIcon}
                        {losingIcon}
                       </ul>
                       {abortIcon}
                    </div>
                );
            }
            else{
                return(
                    <>
                    </>
                );
            }
    }

    setFilter(index, event) {
       this.props.onFilter(index);
    };
  
    render(){
        return (
            <>
            {this.renderFilter()}
            {this.renderFilterV2()}
           </>
        );
       
    }
}
FilterTicket.displayName = componentName;

// PropTypes validation
FilterTicket.propTypes = {
};

// default props
FilterTicket.defaultProps = {
};

FilterTicket.contextTypes = {
    openLinkPopup: PropTypes.func
}

export default FilterTicket;